<template lang="pug">
  div
    b-btn.checklist-item-toggle.text-left.text-white.mt-3(block href='#' v-b-toggle="'accordion' + index" :variant='currentStatus')
      i.font-weight-bold.pr-2(:class='iconClass')
      span.text-left {{ checklistItem.name }}
      i.icon-arrow-down.accordion-icon
    b-collapse(:id="'accordion' + index" :accordion="'accordion' + index" role='tabpanel')
      b-card
        template(v-if='!checklistItem.checked')
          b-card-body
            b-row.py-2
              b-col(sm='12')
                .font-weight-bold.text-secondary.mt-3
                  h3
                    i.icon-clock.pr-2
                    span The operator has not completed the check yet
        template(v-if='checklistItem.checked')
          b-card-body
            b-row.py-2
              b-col(sm='6')
                strong.pr-2 Related component:
                span {{ checklistItem.component_name }}
                span.text-danger.pl-2(v-if='checklistItem.defective')
                  small defective
                br
                strong.pr-2 Operator:
                span {{ (checklistItem.checker) ? checklistItem.checker.full_name : null }}
                br
                strong.pr-2 Evasion date:
                span {{ checklistItem.checked_at }}
              b-col(sm='6')
                b-row
                  b-col(sm='12')
                    p Report number: {{ checklistItem.report_number ? checklistItem.report_number : 'not registered' }}
                b-row
                  b-col(sm='12')
                    template(v-if='canGetDraftReport()')
                      b-button.mr-2(variant='primary' type='button' :href='checklistItem.draft_report_url') Download draft report
                    b-button.mr-2(variant='primary' type='button' :href='checklistItem.final_report_url' :disabled='cannotGetFinalReport()') Download final report
            b-row.py-2
              b-col(sm='6')
                template(v-if='checklistItem.notes')
                  strong.pr-2 Activity notes:
                  p.mt-2 {{ checklistItem.notes }}
                template(v-if='checklistItem.grid_of_inspection')
                  strong.pr-2 Grid of inspection:
                  p.mt-2 {{ checklistItem.grid_of_inspection }}
                template(v-if='checklistItem.instrumental_settings')
                  strong.pr-2 Instrumental settings:
                  p.mt-2 {{ checklistItem.instrumental_settings }}
              b-col(sm='6')
                strong.pr-2 Photos:
                template(v-if='checklistItem.photos.length > 0')
                  carousel.mt-2(
                    :autoplay='carousel.autoplay'
                    :autoplayTimeout='carousel.autoplayTimeout'
                    :perPage='carousel.perPage'
                    :navigationEnabled='carousel.navigationEnabled'
                  )
                    template(v-for='(url, key) in checklistItem.photo_urls')
                      slide
                        a(:href='url' target='_blank')
                          b-img(:src='url' fluid)
                template(v-if='checklistItem.photos.length <= 0')
                  .font-weight-bold.text-secondary.mt-3
                    h3
                      i.icon-exclamation.pr-2
                      span No photos were uploaded


</template>

<script>
  import { Carousel, Slide } from 'vue-carousel'

  import { mapGetters } from 'vuex'

  export default {
    name: 'ShowItem',
    components: { Carousel, Slide },
    data () {
      return {
        carousel: {
          autoplay: true,
          autoplayTimeout: 3000,
          perPage: 1,
          navigationEnabled: true
        },
        currentStatus: 'warning',
        iconClass: 'icon-clock'
      }
    },
    props: {
      index: {
        type: Number,
        default: null
      },
      checklistItem: {
        type: Object,
        default: {}
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'currentUser'
      })
    },
    mounted () {
      this.itemStatus()
    },
    methods: {
      itemStatus () {
        let variant = 'warning'
        let icon = 'icon-clock'
        if (this.checklistItem.checked) {
          variant = 'primary'
          icon = 'icon-check'
          if (this.checklistItem.defective) {
            variant = 'danger'
            icon = 'icon-close'
          }
        }
        this.$set(this.$data, 'currentStatus', variant)
        this.$set(this.$data, 'iconClass', icon)
      },
      canGetDraftReport () {
        if (this.currentUser.role === 'customer' || !this.checklistItem.draft_report_url) { return false }
        return true
      },
      cannotGetFinalReport () {
        if (this.checklistItem.checked && this.checklistItem.final_report_url) { return false }
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Checklist/subcomponents/ShowItem.vue